<template>
  <div>
    <b-modal
      v-model="isModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
    >
      <template #default="props">
        <TicketForm
          :ticket="ticket"
          :reportedBy="profile.username"
          :url="url"
          :meta="meta"
          @close="props.close"
        />
      </template>
    </b-modal>

    <b-tooltip
      :label="ticket ? 'Ticket ' + ticket.status : 'Report game'"
      :type="ticketType(ticket)"
    >
      <b-button
        :type="'is-outlined ' + ticketType(ticket)"
        icon-left="exclamation"
        @click="isModalActive = true"
    /></b-tooltip>
  </div>
</template>

<script>
import TicketForm from "@/components/admins/TicketForm.vue";
import { firestore } from "@/services/firebase";
const ticketsRef = firestore.collection("tickets");

export default {
  components: { TicketForm },

  name: "GameReport",

  props: ["profile", "url", "meta"],

  data() {
    return {
      isModalActive: false,
      tickets: null,
    };
  },

  computed: {
    ticket() {
      if (!this.tickets || !this.tickets.length) return null;
      if (!this.profile || !this.profile.username) return null;
      const tickets = this.profile.isAdmin
        ? [...this.tickets].sort((a, b) =>
            a.status < b.status ? -1 : a.status > b.status ? 1 : 0
          )
        : this.tickets.filter((t) => t.reportedBy === this.profile.username);
      const ticket = tickets.find((t) => t.status !== "deleted");
      if (!ticket) return null;
      return ticket;
    },
  },

  methods: {
    ticketType(ticket) {
      if (!ticket) return "is-danger ";
      if (ticket.status === "created") return "is-primary";
      if (ticket.status === "pending") return "is-warning";
      if (ticket.status === "resolved") return "is-success";
      return "is-danger";
    },
  },

  created() {
    this.$bind("tickets", ticketsRef.where("url", "==", this.url));
  },
};
</script>

<style></style>
